export default {
  state: {
    modalName: '',
    isOpenModal: false,
    modalMessage: '',
    hasLink: ''
  },

  mutations: {
    SET_MODAL_STATUS(state, payload) {
      state.isOpenModal = payload
    },
    SET_MODAL_NAME(state, payload) {
      state.modalName = payload
    },
    SET_MODAL_MESSAGE(state, payload) {
      state.modalMessage = payload
    },
    SET_MODAL_LINK(state, payload) {
      state.hasLink = payload
    }
  },

  actions: {
    updateModalStatus({ commit }, payload) {
      commit('SET_MODAL_STATUS', payload.status)
      commit('SET_MODAL_NAME', payload.name)
      commit('SET_MODAL_MESSAGE', payload.message)
      commit('SET_MODAL_LINK', payload.link)
    }
  },

  getters: {
    modalName: state => state.modalName,
    isOpenModal: state => state.isOpenModal,
    modalMessage: state => state.modalMessage,
    hasLink: state => state.hasLink
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js